/**
 * Normalize a stored image reference from the API before using it in <img src>.
 */
export function normalizeStoredImageRef(url: string | null | undefined): string | null {
	if (!url || typeof url !== 'string') return null;
	const trimmed = url.trim();
	if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return null;
	return trimmed;
}
